export default {
  site_name: '般若智慧',
  site_subtitle: '色即是空 · 感悟般若智慧',
  nav_home: '首页',
  nav_categories: '分类浏览',
  nav_about: '关于我们',
  nav_articles: '文章',
  breadcrumb_home: '首页',
  breadcrumb_category: '分类',
  breadcrumb_article: '文章',
  breadcrumb_about: '关于我们',
  read_more: '阅读全文',
  back_to_home: '返回首页',
  all_articles: '全部文章',
  category_label: '分类',
  read_time: '分钟阅读',
  author_prefix: '作者',
  published_on: '发布于',
  related_articles: '相关文章',
  no_articles: '暂无文章',
  scroll_top: '回到顶部',
  footer_tagline: '以般若智慧照亮人生，用空性哲学安顿心灵。',
  footer_copyright: '© 2024 般若智慧. All rights reserved.',
  footer_links: '快速链接',
  footer_follow: '关注我们',
  contact_email: 'contact@prajna-wisdom.org',
  contact_phone: '+86 400-888-9999',
  contact_address: '浙江省杭州市西湖区灵隐路18号',
};